import React, { useState } from 'react';
import { ArrowRight, Shield, Zap, Award } from 'lucide-react';

const banks = [
  {
    name: 'Akbank',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/a80c0972-6830-4dc4-b3bc-e236c7fbb5ea.png',
    type: 'İhtiyaç Kredisi',
    features: [
      { title: 'Anında onay', description: '5 dakika içinde sonuç' },
      { title: 'Masrafsız kullanım', description: 'Dosya masrafı yok' },
      { title: 'Özel faiz', description: '%20 indirimli oran' }
    ],
    advantages: ['En hızlı onay', 'En düşük faiz', '7/24 başvuru']
  },
  {
    name: 'QNB',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/d9ae3539-f63d-4295-84e6-08dbe6e2a6d6.png',
    type: 'İhtiyaç Kredisi',
    features: [
      { title: '%20 indirimli faiz', description: 'Özel müşteri avantajı' },
      { title: 'Online başvuru', description: 'Şubeye gitmeye gerek yok' },
      { title: 'Esnek vade', description: '60 aya varan vade' }
    ],
    advantages: ['Düşük faiz', 'Esnek vade', 'Kolay başvuru']
  },
  {
    name: 'Garanti BBVA',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/2c60a02b-d37c-48ce-ad8e-deb4e57bf810.jpg',
    type: 'İhtiyaç Kredisi',
    features: [
      { title: 'Masrafsız işlem', description: 'Sıfır dosya masrafı' },
      { title: 'Dijital onay', description: 'Anında kredi kullanım' },
      { title: 'Özel kampanya', description: 'İlk krediye özel oran' }
    ],
    advantages: ['Masrafsız', 'Dijital', 'Hızlı onay']
  },
  {
    name: 'Yapı Kredi',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/52f6626d-498d-4e76-8fb5-fd4381a1e0db.png',
    type: 'İhtiyaç Kredisi',
    features: [
      { title: 'Kefilsiz kredi', description: 'Teminatsız kullanım' },
      { title: '3 ay erteleme', description: 'Ödemelere 3 ay ara' },
      { title: 'SMS ile başvuru', description: 'Tek SMS ile onay' }
    ],
    advantages: ['Kefilsiz', 'Erteleme', 'SMS onay']
  }
];

const BankComparison = () => {
  const [hoveredBank, setHoveredBank] = useState<string | null>(null);

  return (
    <div className="space-y-8">
      {/* Bank Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {banks.map((bank) => (
          <div
            key={bank.name}
            className={`bg-white rounded-2xl overflow-hidden border transition-all duration-300
              ${hoveredBank === bank.name
                ? 'border-[#F7BA45] shadow-xl scale-[1.02]'
                : 'border-slate-200 hover:border-[#F7BA45]/50 shadow-lg'
              }`}
            onMouseEnter={() => setHoveredBank(bank.name)}
            onMouseLeave={() => setHoveredBank(null)}
          >
            {/* Header */}
            <div className="p-6 flex items-center gap-4 border-b border-slate-200">
              <img src={bank.logo} alt={bank.name} className="h-8 object-contain" />
              <p className="text-sm text-slate-600">{bank.type}</p>
            </div>

            {/* Features */}
            <div className="p-6 space-y-6">
              <div className="space-y-3">
                {bank.features.map((feature, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="bg-[#F7BA45]/10 p-2 rounded-lg">
                      {index === 0 ? <Zap size={16} className="text-[#F7BA45]" /> :
                       index === 1 ? <Shield size={16} className="text-[#F7BA45]" /> :
                       <Award size={16} className="text-[#F7BA45]" />}
                    </div>
                    <div>
                      <p className="font-medium text-slate-800">{feature.title}</p>
                      <p className="text-sm text-slate-600">{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Action Button */}
            <div className="p-4 bg-slate-50">
              <button className="w-full bg-[#F7BA45] hover:bg-[#e5ac3d] text-slate-900 font-medium py-3 px-6 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 group shadow-md hover:shadow-lg">
                İNCELE
                <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BankComparison;